var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Service, { inject as service } from '@ember/service';
/**
 * Encode given buffer or decode given string with Base64URL.
 * Can also decode a given string (for example person token which is not base64) to base64
 */
const base64url = {
  encode: function (buffer) {
    const base64 = window.btoa(String.fromCharCode(...new Uint8Array(buffer)));
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
  },
  encodeString: function (buffer) {
    const base64 = window.btoa(buffer);
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
  },
  decode: function (base64url) {
    const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
    const binStr = window.atob(base64);
    const bin = new Uint8Array(binStr.length);
    for (let i = 0; i < binStr.length; i++) {
      bin[i] = binStr.charCodeAt(i);
    }
    return bin.buffer;
  }
};
const preOptions = {
  authenticator_selection_criteria: {
    resident_key: 'required',
    requires_resident_key: true,
    user_verification: 'required'
  },
  attestation_conveyance_preference: 'none'
};
const SHOW_AGAIN_DAYS = 7;
const NEVER_SHOW_AGAIN_DAYS = 365 * 1000;
// To test locally, add to options options.rp.id = 'localhost';
let EmberMultipassPasskeysService = (_dec = service('ember-multipassfe-client'), _dec2 = service('ember-multipass-tracking'), _dec3 = service('ember-multipass-logging'), _dec4 = service('ember-multipass-storage'), (_class = class EmberMultipassPasskeysService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor, this);
    _initializerDefineProperty(this, "tracking", _descriptor2, this);
    _initializerDefineProperty(this, "logger", _descriptor3, this);
    _initializerDefineProperty(this, "storage", _descriptor4, this);
    _defineProperty(this, "abortController", null);
    _defineProperty(this, "verification_types", Object.freeze({
      NO_VERIFICATION: 'NO_VERIFICATION',
      PASSWORD: 'PASSWORD',
      TWO_FACTOR: 'TWO_FACTOR'
    }));
    /**
     * Create and register a new passkey
     * @returns {Promise<boolean>} `true` if the passkey was successfully registered, `false` if the user needs to verify their identity.
     */
    _defineProperty(this, "registerCredential", async ({
      personToken,
      verificationHandler,
      password
    }) => {
      const {
        registration_id,
        public_key_credential_options,
        verification
      } = await this.multipassfeClient.registerPasskey(password ? {
        ...preOptions,
        password
      } : preOptions);
      if (verification === this.verification_types.TWO_FACTOR || verification === this.verification_types.PASSWORD) {
        verificationHandler(verification);
        return false;
      }
      const options = JSON.parse(public_key_credential_options);
      if (!options || !registration_id) {
        throw new Error('Did not get necessary information from server');
      }

      // Base64URL decode some values
      options.user.id = base64url.decode(base64url.encodeString(personToken));
      options.challenge = base64url.decode(options.challenge);
      options.attestationType = 'none';
      options.user.displayName = options.user.name;
      if (options.excludeCredentials) {
        for (const cred of options.excludeCredentials) {
          cred.id = base64url.decode(cred.id);
        }
      }

      // Invoke WebAuthn create
      const cred = await navigator.credentials.create({
        publicKey: options
      });
      if (!cred) {
        throw new Error("Couldn't create the credential");
      }
      const credential = {};
      credential.id = cred.id;
      // Base64URL encode `rawId`
      credential.rawId = base64url.encode(cred.rawId);
      credential.type = cred.type;

      // Base64URL encode some values
      const clientDataJSON = base64url.encode(cred.response.clientDataJSON);
      const attestationObject = base64url.encode(cred.response.attestationObject);

      // Obtain transports if they are available.
      const transports = cred.response.getTransports ? cred.response.getTransports() : [];
      credential.response = {
        clientDataJSON,
        attestationObject,
        transports
      };
      let response = {
        public_key_credential: JSON.stringify(credential),
        registration_id
      };
      if (password) {
        response = {
          ...response,
          password: password
        };
      }
      await this.multipassfeClient.registerPasskey(response, {
        createToken: true
      });
      return true;
    });
    _defineProperty(this, "getRegisterCredentialVerificationType", async () => {
      const {
        verification
      } = await this.multipassfeClient.registerPasskey(preOptions);
      return verification;
    });
    /**
     * Request to deregister a passkey.
     * @param { string } credId A Base64URL encoded credential ID of the passkey to unregister.
     * @returns a promise that states whether the operation was successful or not
     */
    _defineProperty(this, "deregisterPasskey", async ({
      credId,
      verificationHandler,
      password
    }) => {
      const data = {};
      if (credId) data.credential_id = credId;
      if (password) data.password = password;
      const {
        verification
      } = await this.multipassfeClient.deregisterPasskey(data);
      if (verification === this.verification_types.TWO_FACTOR || verification === this.verification_types.PASSWORD) {
        verificationHandler(verification);
        return false;
      }
      return true;
    });
    /**
     * Request to get the verification status of a passkey deregistration.
     * @returns a promise that resolves with the verification status.
     */
    _defineProperty(this, "getDeregisterPasskeyVerificationStatus", async () => {
      const {
        verification
      } = await this.multipassfeClient.deregisterPasskey();
      return verification;
    });
    /**
     * Gets information from local storage regarding whether to show passkeys promo
     * @returns {boolean}
     */
    _defineProperty(this, "showPromoDontRemindAgain", () => {
      const dontRemindAgainDate = this.storage.getPasskeyPromoViewDontRemindDate();
      if (!dontRemindAgainDate) return true;
      return Date.now() >= new Date(dontRemindAgainDate).getTime();
    });
    /**
     * When user chooses to no longer be reminded, or to be reminded later, we set in local storage the date in which we will show again
     */
    _defineProperty(this, "setPromoDontRemindAgain", neverShowAgain => {
      const expiryDays = neverShowAgain ? NEVER_SHOW_AGAIN_DAYS : SHOW_AGAIN_DAYS;
      const expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + expiryDays);
      this.storage.setPasskeyPromoViewDontRemindDate(expiryDate);
    });
    /**
     * Fully remove promo-view key from local storage
     */
    _defineProperty(this, "removePromoDontRemindAgain", () => {
      this.storage.removePasskeyPromoViewDontRemindDate();
    });
  }
  /**
   * Authenticate with a passkey.
   * @param { boolean } conditional Set to `true` if this is for a conditional UI.
   * @returns A promise that resolves with a server response.
   */
  async authenticate(conditional = false) {
    if (this.abortController) {
      this.abortController.abort('ABORTED_BY_SIGNAL');
      this.abortController = new AbortController();
    } else {
      this.abortController = new AbortController();
    }
    if (!this.multipassfeClient.passkeyAuthPublicKeyCredentialRequestOptions) {
      this.logger.error('Did not get necessary information from server');
      return;
    }
    const options = JSON.parse(this.multipassfeClient.passkeyAuthPublicKeyCredentialRequestOptions);
    const authentication_id = options.challenge;
    options.challenge = base64url.decode(options.challenge);
    if (options.allowCredentials) {
      for (const allowCred of options.allowCredentials) {
        allowCred.id = base64url.decode(allowCred.id);
      }
    }
    const cred = await navigator.credentials.get({
      publicKey: options,
      mediation: conditional ? 'conditional' : 'optional',
      signal: this.abortController.signal
    });
    if (!cred) {
      this.logger.error('No credential returned from web authn');
      return;
    }
    const credential = {};
    credential.id = cred?.id;
    credential.type = cred?.type;
    // Base64URL encode `rawId`
    credential.rawId = base64url.encode(cred?.rawId);
    // Base64URL encode some values
    const clientDataJSON = base64url.encode(cred.response?.clientDataJSON);
    const authenticatorData = base64url.encode(cred.response?.authenticatorData);
    const signature = base64url.encode(cred.response?.signature);
    const userHandle = base64url.encode(cred.response?.userHandle);
    credential.response = {
      clientDataJSON,
      authenticatorData,
      signature,
      userHandle
    };
    return {
      publicKeyCredential: JSON.stringify(credential),
      authenticationId: authentication_id
    };
  }

  /**
   * Request to update the name of a passkey.
   * @param { string } credentialId A Base64URL encoded credential ID of the passkey to update.
   * @param { string } name A new name for the passkey.
   * @returns a promise that resolves with a server response.
   */
  updatePasskey(credentialId, name) {
    return this.multipassfeClient.updatePasskey({
      credential_id: credentialId,
      name
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "tracking", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "storage", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { EmberMultipassPasskeysService as default };